import type { ReactNode } from 'react';
import { EmptyTitle } from '@monksflow/monks-ui';
import { twMerge } from 'tailwind-merge';

interface Props {
  children: ReactNode;
  className?: string;
}

/**
 * House variant of monks-ui's `EmptyTitle`: the canonical empty-state
 * typography (`text-2xl text-foreground`, which every call site was
 * overriding by hand) plus heading semantics — the design-system component
 * renders a bare `<div>`, which drops empty-state titles from screen-reader
 * heading navigation. Page titles are `<h1>` (SectionPageHeaderTitle), so
 * empty states sit one level below. Delete this wrapper if monks-ui
 * ships a real heading element on `EmptyTitle`.
 *
 * Merged rather than concatenated, so a caller's own type step replaces the
 * canonical one instead of racing it on source order.
 */
export function EmptyStateTitle(props: Props) {
  return (
    <EmptyTitle
      role="heading"
      aria-level={2}
      className={twMerge('text-2xl text-foreground', props.className)}
    >
      {props.children}
    </EmptyTitle>
  );
}
